export enum DocumentRelatedType {
  User = 'App\\Models\\User',
  WorkingContract = 'App\\Models\\WorkingContract',
  WorkingContractVariableCondition = 'App\\Models\\WorkingContractVariableCondition',
  HealthInsuranceContract = 'App\\Models\\HealthInsuranceContract',
  HealthInsuranceContractCard = 'App\\Models\\HealthInsuranceContractCard',
  AbsenceRequest = 'App\\Models\\AbsenceRequest',
}

export const DocumentRelatedTypeLabels: Record<DocumentRelatedType, string> = {
  [DocumentRelatedType.User]: 'Usuario',
  [DocumentRelatedType.WorkingContract]: 'Contrato de Trabajo',
  [DocumentRelatedType.WorkingContractVariableCondition]: 'Condición Variable de Contrato',
  [DocumentRelatedType.HealthInsuranceContract]: 'Contrato de Seguro de Salud',
  [DocumentRelatedType.HealthInsuranceContractCard]: 'Tarjeta de Seguro de Salud',
  [DocumentRelatedType.AbsenceRequest]: 'Solicitud de Ausencia',
};
